export const AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_BEGIN =
  'syftacp/AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_BEGIN' as const
export const AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_SUCCEEDED =
  'syftacp/AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_SUCCEEDED' as const
export const AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_FAILED =
  'syftacp/AGENCY_CASCADE_SCHEDULING_PLAN_FETCH_FAILED' as const
